import React from 'react';
import { useSnackbar } from 'notistack';
import NotificationItem from '@components/notification/item';

const getDefaultOptions = (type) => ({
  content: (key, message) => (
    <NotificationItem
      id={key}
      message={message}
      variant={type}
    />
  ),
  preventDuplicate: true,
});

const useSnackMessage = () => {
  const { enqueueSnackbar } = useSnackbar();

  const showMessage = (msg, type, options = {}) => {
    const key = enqueueSnackbar(
      msg,
      { ...getDefaultOptions(type || 'error'), ...options },
    );
    return key;
  };

  return showMessage;
};

export default useSnackMessage;
